import { motion, useAnimation } from 'framer-motion';
import { useEffect } from 'react';

type ProgressBarProps = {
  remainingTime: number;
  isPaused: boolean;
};

const ProgressBar = ({ remainingTime, isPaused }: ProgressBarProps) => {
  const controls = useAnimation();

  useEffect(() => {
    if (!isPaused) {
      controls.start({
        width: '100%',
        transition: {
          duration: remainingTime / 1000,
          ease: 'linear',
        },
      });
    } else {
      controls.stop();
    }
  }, [isPaused, remainingTime]);

  return (
    <motion.div
      className="!m-0 absolute top-0 left-0 h-full rounded-lg bg-fjsWhite opacity-10 pointer-events-none"
      initial={{ width: 0 }}
      animate={controls}
    />
  );
};

export default ProgressBar;
